/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SessionInfoDto } from '../../models/session-info-dto';

export interface GetSessionInfo$Params {
  'X-API-Version'?: string;
}

export function getSessionInfo(http: HttpClient, rootUrl: string, params?: GetSessionInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<SessionInfoDto>> {
  const rb = new RequestBuilder(rootUrl, getSessionInfo.PATH, 'get');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SessionInfoDto>;
    })
  );
}

getSessionInfo.PATH = '/api/session';
